/* =========================================================================
   Google sign-in kill-switch.

   Google sign-up / sign-in is hidden for now — new accounts come in through
   email + password only, until we decide to turn Google back on.

   🚩 SHELVED, NOT DELETED. Flip SHOW_GOOGLE_SIGN_IN to `true` and the
   "Sign in with Google" button comes back exactly as it was on every auth
   page. The buttons and their handlers (googleSignIn / googleSignUp in
   UserContext.js) are untouched, just not rendered.

   Two things this flag does NOT do:
     - It does not disable the Google provider in Firebase Auth. Anyone who
       already has a Google-created account still has one; they simply have
       no button to use it. Turn the provider off in the Firebase console if
       you want it truly closed.
     - It does not hide the Google button on /components, which is the
       Argon template's component gallery, not a real page.
   ========================================================================= */

export const SHOW_GOOGLE_SIGN_IN = false;

export default SHOW_GOOGLE_SIGN_IN;
